import { combineReducers } from 'redux';
import information from './get-information';
import updateInformation from './update-information';
import customization from './customization';
import changePassword from './change-password';
import putPassword from './put-information';

const user = combineReducers({
  information,
  updateInformation,
  customization,
  changePassword,
  putPassword
});

export default user;
